import React from "react";
import { cn } from "@/lib/utils";
import { initialsOf } from "@/lib/format";

export default function UserAvatar({ name, className, size = 28 }) {
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-accent text-accent-foreground font-mono text-[10px] font-semibold border border-border",
        className
      )}
      style={{ width: size, height: size }}
      title={name || ""}
    >
      {initialsOf(name)}
    </div>
  );
}
